<template>
  <div class="sky_wrap">
    <div class="sky_btn">
      <div class="sky_item" v-for="(item, index) in skyList" :key="index" :class="activeIndex === index ? 'active' : ''"
        @click="changeIndex(index)">
        {{ item.tit }}
      </div>
    </div>
    <div class="sky_content">
      <div class="content_left">
        <div class="left_tit">{{ skyTitle }}</div>
        <div class="left_icon_wrap">
          <div class="icon_item" v-for="(item, index) in skyImgList" :key="index" ref="iconItem">
            <i :class="item.src"></i>
            <span v-html="item.txt"></span>
          </div>
        </div>
        <!-- <div class="left_btn hidden-xs-only" @click="handleToDeomo">获取产品演示</div> -->
      </div>
      <div class="content_right">
        <img :src="skycurrentImg" alt="" />
        <!-- <div class="left_btn hidden-sm-and-up" @click="handleToDeomo">获取产品演示</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      skyTitle:
        '',
      skyImgList: [],
      skycurrentImg: ''
    }
  },
  props: {
    skyList: {
      type: Array,
      default: [],
    },
    detailsArr: {
      type: Array,
      default: [],
    },
  },
  methods: {
    changeIndex(index) {
      this.activeIndex = index
      this.skyTitle = this.detailsArr[index].Title
      this.skyImgList = this.detailsArr[index].SubTitle.reduce((pre, cur) => {
        pre.push({
          src: '',
          txt: cur
        })
        return pre
      }, [])
      this.skycurrentImg = this.detailsArr[index].Image
    },
    handleToDeomo() {
      // this.$router.push('/demo')
    }
  },
}
</script>

<style lang="scss" scoped>
.sky_wrap {
  width: 70%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;

  @media screen and (max-width: 768px) {
    width: 95%;
    background: #f7f7f7;
  }

  .sky_btn {
    width: 100%;
    display: flex;

    .sky_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;

      @media screen and (max-width: 768px) {
        height: 60px;
        text-align: center;
        font-size: 13px;
      }
    }

    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;

      &::before {
        content: '▲';
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
  }

  .sky_content {
    width: 100%;
    display: flex;
    padding: 30px;
    justify-content: center;

    @media screen and (max-width: 768px) {
      flex-direction: column;
    }

    .content_left {
      width: 40%;

      @media screen and (max-width: 768px) {
        width: 100%;
      }

      .left_tit {
        color: #2d3937;
        font-size: 17px;
        min-height: 90px;
        line-height: 20PX;

        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          padding: 10px 20px;
          color: #646464;
        }
      }

      .left_icon_wrap {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 30px;

        @media screen and (max-width: 768px) {
          justify-content: center;
        }

        .icon_item {
          width: 90%;
          height: 50px;

          @media screen and (max-width: 768px) {
            height: 50px;
          }

          i {
            color: #7bbde3;

            @media screen and (max-width: 768px) {
              font-size: 20px;
            }
          }

          span {
            color: #646464;

            @media screen and (max-width: 768px) {
              font-size: 14px;
            }
          }
        }
      }

      .left_btn {
        width: 150PX;
        height: 40PX;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
      }
    }

    .content_right {
      width: 40%;

      @media screen and (max-width: 768px) {
        width: 100%;
        text-align: center;
      }

      text-align: right;

      img {
        margin-top: 30px;
        width: 80%;
      }

      .left_btn {
        width: 180px;
        height: 50px;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
        cursor: pointer;

        @media screen and (max-width: 768px) {
          width: 120px;
          height: 35px;
          font-size: 14px;
          border-radius: 20px;
          margin: 20px auto;
          cursor: pointer;
        }
      }
    }
  }
}
</style>